import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { IDSAuthService } from './idsauth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(
    private idsAuthService: IDSAuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

    if (this.idsAuthService.isAuthenticated()) {
      localStorage.removeItem('resend_route');
      return true;
    }
    // Not authenticated — save current URL so callback can redirect back after login
    localStorage.setItem('resend_route', state.url);
    return this.router.createUrlTree(['/login']);
  }
}

